
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      // var winterPrice = document.getElementById("winterCartPrice").value;
      // var cartPrice = this.dataset.price - winterPrice;
      // if (this.dataset.winter != 1 && winterPrice != 0 && cartPrice <= 999) {
      //   cartItems.removeExtraPoduct(this.dataset.index, "remove");
      // } else {
      //   cartItems.updateQuantity(this.dataset.index, 0);
      // }
       cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      // On a PDP/quick-add add, CartDrawer.renderContents already applied the lightweight drawer
      // update from the add response. Skip the redundant fetch so the drawer isn't re-rendered twice.
      if (event.source === 'product-form' && this.tagName === 'CART-DRAWER-ITEMS') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      //this.validateQuantity(event);
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.onCheckAddons(event);
    }
  }

  onCheckAddons(event) {
    // var winterPrice = document.getElementById("winterCartPrice").value;
    // var cartPrice = event.target.dataset.price - winterPrice;
    // const inputValue = parseInt(event.target.value);
    // const index = event.target.dataset.index;
    // if (
    //   document.activeElement.getAttribute("name") != "plus" &&
    //   event.target.dataset.winter != 1 &&
    //   winterPrice != 0 &&
    //   cartPrice <= 499
    // ) {
    //   this.removeExtraPoduct(event, "");
    // } else {
    //   this.updateQuantity(
    //     event.target.dataset.index,
    //     event.target.value,
    //     document.activeElement.getAttribute("name"),
    //     event.target.dataset.quantityVariantId
    //   );
    // }
  this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  // removeExtraPoduct(event, tar) {
  //   let isExecuted = confirm(
  //     "After removing this product, order value will now be less than Rs 999.The summer reward will also be removed from the cart.",
  //     "Anveshan Summer Reward Product"
  //   );
  //   if (isExecuted) {
  //     var winterId = document.getElementById("winterCartId").value;
  //     let data = { line: winterId, quantity: 0 };
  //     let cartContents = fetch("/cart/change.js", {
  //       method: "POST",
  //       credentials: "same-origin",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(data),
  //     }).then((response) => {
  //       if (tar == "remove") {
  //         let line_id = (event > winterId)?event-1:event;
  //         this.updateQuantity(line_id, 0);
  //       } else {
  //         let line_id = (event.target.dataset.index > winterId)?event.target.dataset.index-1:event.target.dataset.index;
  //         this.updateQuantity(
  //           line_id,
  //           event.target.value,
  //           document.activeElement.getAttribute("name"),
  //           event.target.dataset.quantityVariantId
  //         );
  //       }
  //     });
  //   }
  // }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      // Fetch ONLY the lightweight cart-items-list (items + price summary) instead of the whole
      // heavy cart-drawer section. Saves server render time on every cross-component cart update
      // (quick-add, blinkit, quick-order, etc.).
      fetch(`${routes.cart_url}?section_id=cart-items-list`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          // Cart emptied: the lightweight section has no empty-state — do a full drawer render.
          if (!html.querySelector('.cart-item')) {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderFullCartDrawer === 'function') drawer.renderFullCartDrawer();
            return;
          }
          requestAnimationFrame(() => {
            const applied = typeof window.applyCartItemsList === 'function' && window.applyCartItemsList(responseText);
            // Drawer was showing empty-state (no items-list to swap) → full drawer render.
            const drawer = document.querySelector('cart-drawer');
            if (!applied && drawer && typeof drawer.renderFullCartDrawer === 'function') drawer.renderFullCartDrawer();
          });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      // Use this cart's actual section id (cart.json key) — NOT the stock "main-cart-items",
      // otherwise Shopify renders the standalone stock section and overwrites the custom cart.
      const cartSectionId = this.dataset.sectionId || 'main-cart-items';
      fetch(`${routes.cart_url}?section_id=${cartSectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) requestAnimationFrame(() => { this.innerHTML = sourceQty.innerHTML; });
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Pre-compute section HTML updates before touching DOM
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const sectionUpdates = [];
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          const newHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          sectionUpdates.push([elementToReplace, newHTML]);
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          message = typeof updatedValue === 'undefined'
            ? window.cartStrings.error
            : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }

        // Batch all DOM writes in a single rAF for better INP
        requestAnimationFrame(() => {
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          for (const [el, html] of sectionUpdates) el.innerHTML = html;

          const cartItemsContainer = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
          if (cartItemsContainer) cartItemsContainer.classList.remove('cart__items--disabled');

          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          const focusTarget = lineItem ? lineItem.querySelector(`[name="${name}"]`) : null;
          if (focusTarget) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, focusTarget)
              : focusTarget.focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        typeof(renderPopPrices)==='function' && renderPopPrices(true);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  _getCartItemsContainer() {
    return document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
  }

  _getSpinners(line) {
    return this.querySelectorAll(`#CartItem-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__spinner`);
  }

  enableLoading(line) {
    const mainCartItems = this._getCartItemsContainer();
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
    this._getSpinners(line).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = this._getCartItemsContainer();
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
    this._getSpinners(line).forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
